export const JSON_VIEWER = {
  BG: "#1e1e1e",
  KEY_COLOR: "#9cdcfe",
  STRING_COLOR: "#ce9178",
  NUMBER_COLOR: "#b5cea8",
  NULL_COLOR: "#569cd6",
  LINE_NUM_COLOR: "#858585",
  INDENT_SPACES: 2
} as const;

export const UP1_DOMAIN = "https://up1.autodesk.com";

export const UP_DOMAIN = "https://up.autodesk.com";

/** Primary APP support / FAQ documentation (Confluence). */
export const SUPPORT_DOCUMENTATION_URL = "https://autodesk.atlassian.net/wiki/x/scSoIg";

export const HOME_PAGE_CONTENT = {
  description: `Autodesk Publishing Platform (APP), is a robust and cloud-based platform, engineered to accelerate and simplify the publishing and release of Autodesk software. This platform is primarily guided by the publishing job request, which varies depending on the specific needs of the publishing, be it for a product, update, or component. Please click on the below links to learn more. Please click on the 'Get Started' button to publish/submit job using the UI.`,
  tiles: [
    {
      title: "Yaml schema",
      text: "Autodesk Publishing Platform uses YAML field details to define the parameters necessary for creating a comprehensive and effective publishing job.",
      link: "https://autodesk.atlassian.net/wiki/x/Xf_nIg"
    },
    {
      title: "Publishing a product",
      text: "Learn the step-by-step process for publishing your product. This guide covers everything from preparing your job request and  navigating the submission portal and managing the build job.",
      link: "https://autodesk.atlassian.net/wiki/x/Z-_nIg"
    },
    {
      title: "Publishing product update",
      text: "Learn the step-by-step process for publishing your product upgrade. This guide covers everything from preparing your job request and  navigating the submission portal and managing the build job.",
      link: "https://autodesk.atlassian.net/wiki/x/0yioIg"
    },
    {
      title: "Publishing a component",
      text: "Learn the step-by-step process for publishing your component. This guide covers everything from preparing your job request and  navigating the submission portal and managing the build job.",
      link: "https://autodesk.atlassian.net/wiki/x/gP_nIg"
    },
    {
      title: "How to release a product",
      text: "Step-by-step guide to creating, validating, and publishing product releases in APP, including job setup, documents, image review, state transitions (Draft, Preview, Live, Discontinued), and retirement.",
      link: "https://autodesk.atlassian.net/wiki/x/SmmoIg"
    },
    {
      title: "How to release a update",
      text: "Step-by-step guide to creating, validating, and publishing update releases in APP, including job setup, documents, image review, state transitions (Draft, Preview, Live, Discontinued), and retirement.",
      link: "https://autodesk.atlassian.net/wiki/x/t4crKw"
    },
    {
      title: "How to release a component",
      text: "Step-by-step guide to creating, validating, and publishing component releases in APP, including job setup, documents, image review, state transitions (Draft, Preview, Live, Discontinued), and retirement.",
      link: "https://autodesk.atlassian.net/wiki/x/mogqKw"
    },
    {
      title: "Support",
      text: "Need help? Start with our support documentation where we provide comprehensive guidance for The Autodesk Publishing Platform, addressing common queries.",
      link: SUPPORT_DOCUMENTATION_URL
    }
  ]
};

export const PUBLISHING: Record<string, string> = {
  PRODUCT: "Product",
  PRODUCT_MAJOR_UPGRADE: "Product (Major Upgrade)",
  BADGE_ICON: "Badge/Icon",
  UPDATE: "Update",
  COMPONENT: "Component",
  EXTENSION: "Extension",
  LIBRARY: "Library",
  FILE: "File (release notes, etc...)",
  ENGINE: "Engine",
  LANGUAGE_PACK: "Language Pack",
  PLUG_IN: "Plug-in"
};

interface Config {
  autoUpdateTime: number;
}

export const config: Config = {
  autoUpdateTime: 60000
};
